export enum Actions {
    FETCH_DATA = 'FETCH_DATA',
    POST_DATA = 'POST_DATA',
    SUBMIT_MOBILE_NUMBER = 'SUBMIT_MOBILE_NUMBER',
}
